import type { WeblinksListApiV4Response } from 'reactApp/modules/allDocuments/allDocuments.types';
import { defaultSortInAllDocs } from 'reactApp/modules/sort/sort.selectors';
import type { Sort } from 'reactApp/types/Tree';

import { APICallV4Post } from '../APICall';

class WeblinksLinksApiCall extends APICallV4Post<WeblinksListApiV4Response> {
    _method = 'weblinks/list';
}

interface IWeblinksLinksApiCall {
    limit: number;
    cursor?: string;
    exts?: string;
    sort?: Sort;
}

export const weblinksLinksApiCall = async ({ limit, cursor = '', exts = '', sort = defaultSortInAllDocs }: IWeblinksLinksApiCall) =>
    (await new WeblinksLinksApiCall().makeRequest({ limit, cursor, exts, sort: sort?.type, order: sort?.order }))?.data;
